import { environment } from '../environments/environment';
import { EntitlementEnum } from '@streamamg/cloud-matrix-lib';

export const configs = {
  google: {
    gtm: 'GTM-NVP26SP',
  },
  carouselItemSize: 25,
  playlistPageSize: 50,
  generalContentPageSize: 24,
  browseContentPageSize: {
    default: 24,
    fhd: 25,
    qhd: 30,
    uhd: 35,
  },

  streamPlayEndPoint: `https://${environment.streamPlay.production ? '' : 'staging.'}api.streamplay.streamamg.com/fixtures/basketball/p/3001497`,

  kaltura: {
    kalturaBaseUrl: 'https://open.http.mp.streamamg.com',
    partnerId: '3001497',
    uiConfId: '30030251', // '30030343' v2.55,
    flashvars: {
      'playerSeekButtonAMG.plugin': true,
      'currentTimeLabel.order': 10,
      'liveStatus.order': 11,
      'durationLabel.order': 12,
      'playPauseBtn.order': 40,
      'volumeControl.order': 100,
      'chromecast.order': 80,
      'sourceSelector.order': 70,
      'fullScreenBtn.order': 50,
      'fullScreenBtn.parent': 'videoHolder',
      // 'volumeControl.showSlider': false,
      IframeCustomPluginCss1: '/video-player.css',
    }
  },

  cloudMatrix: {
    defaultEntitlement: EntitlementEnum['*'], // freemium
    feed: 'https://cebl-cm.streamamg.com/api/v1/c78c212a-b927-4a73-977a-ef743aa2d10f/cgI8v6kfVoiGgGyAWBVgG9r9GgH5kgh6drSbsRlGDYpnA9pwua/46ee8945-eeb5-4138-8cda-4cdc39c1c0fe/en/feed/9c643c0c-fb6c-4a06-8008-74e432f9abf0/sections/?section=3ed2597e-8bcc-4e79-9f87-636addbafbcc',
  },

  wordpress: {
    paths: {
      api: `${environment.wordpress.baseUrl}/wp-json/wpa/v2`,
      menusApi: `${environment.wordpress.baseUrl}/wp-json/menus/v1/menus`,
    },
    subPaths: {
      categories: '/category',
      teams: '/team',
      documentaries: '/documentary',
      commonData: '/common_field?slug=common-fields',
    },
  },

};
